"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2016-present, Prometheus Research, LLC. MIT License
 *
 * 
 */

var PseudoClassSet = {
  focus: true,
  hover: true,
  active: true,
  checked: true,
  default: true,
  disabled: true,
  empty: true,
  enabled: true,
  firstChild: true,
  firstOfType: true,
  fullscreen: true,
  indeterminate: true,
  invalid: true,
  lastChild: true,
  lastOfType: true,
  link: true,
  onlyChild: true,
  optional: true,
  required: true,
  root: true,
  scope: true,
  target: true,
  valid: true,
  visited: true
};

exports.default = PseudoClassSet;
